__turbopack_context__.v({
  "cta-button": "consent-gate-module-scss-module__5F4ONG__cta-button",
  "cta-label": "consent-gate-module-scss-module__5F4ONG__cta-label",
  "disclaimer": "consent-gate-module-scss-module__5F4ONG__disclaimer",
  "message-icon": "consent-gate-module-scss-module__5F4ONG__message-icon",
  "message-row": "consent-gate-module-scss-module__5F4ONG__message-row",
  "overlay": "consent-gate-module-scss-module__5F4ONG__overlay",
  "panel": "consent-gate-module-scss-module__5F4ONG__panel",
  "play-circle": "consent-gate-module-scss-module__5F4ONG__play-circle",
  "remember-checkbox": "consent-gate-module-scss-module__5F4ONG__remember-checkbox",
  "remember-helper": "consent-gate-module-scss-module__5F4ONG__remember-helper",
  "remember-section": "consent-gate-module-scss-module__5F4ONG__remember-section",
  "terms-link": "consent-gate-module-scss-module__5F4ONG__terms-link",
});
